import { useQuery } from '@tanstack/react-query'
import type { ISpProfileCompleteness, ISpProfilePublic } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'
import { useSessionStore } from '@/stores/useSessionStore'

export function useSpProfile() {
  const isGuest = useSessionStore((s) => s.user?.guest === true)
  return useQuery({
    queryKey: queryKeys.spProfile.detail(),
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ISpProfilePublic>>(
        '/api/v1/sp/profile',
      )
      return data.data
    },
    enabled: !isGuest,
  })
}

export function useSpProfileCompleteness(enabled = true) {
  return useQuery({
    queryKey: queryKeys.spProfile.completeness(),
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ISpProfileCompleteness>>(
        '/api/v1/sp/profile/completeness',
      )
      return data.data
    },
    enabled,
  })
}
